import React from 'react';
import {
  ProductGalleryCard,
  ProductGalleryCardProps,
} from '@sparknz/journeys-common';

import { CardLinkRegion } from 'shared/components';
import { ProductGalleryCardAnchor } from 'shared/components/ProductGalleryCard';
import { useQuery, useSegment } from 'shared/hooks';
import {
  convertToArray,
  extractFirstValue,
  getFeaturedPromoDeals,
  getPromotionByType,
  PromotionType,
} from 'shared/utils';
import DeviceGalleryCardImpressionRegion from './analytics/DeviceGalleryCardImpressionRegion';
import { trackOpenProductDetails } from './analytics/trackOpenProductDetails.utils';

export interface DeviceGalleryCardProps extends ProductGalleryCardProps {
  numProducts: number;
  selectedSubcategoryId: string;
}

const DeviceGalleryCard = ({
  numProducts,
  product,
  selectedSubcategoryId,
  eagerLoadImage,
  isBusiness,
}: DeviceGalleryCardProps) => {
  const { promotions } = product || {};
  const { segment, channel } = useSegment();

  const { query } = useQuery();
  const sortOrder = extractFirstValue(query.sort);

  const selectedBrandValues = convertToArray(query.brand);
  const selectedColorValues = convertToArray(query.color);
  const selectedPrice = convertToArray(query.price);

  const promoTag = getPromotionByType(
    promotions,
    PromotionType.MARKETING,
  )?.name;
  const promoDealString = getFeaturedPromoDeals(promotions);

  const handleAnalyticsClickEvent = () => {
    trackOpenProductDetails({
      segment,
      channel,
      product,
    });
  };

  return (
    <DeviceGalleryCardImpressionRegion
      numProducts={numProducts}
      product={product}
      promoDealString={promoDealString}
      promoTag={promoTag}
      selectedBrandValues={selectedBrandValues}
      selectedColorValues={selectedColorValues}
      selectedPrice={selectedPrice}
      selectedSubcategoryId={selectedSubcategoryId}
      sortOrder={sortOrder}
    >
      <CardLinkRegion regionId="productGallery">
        <ProductGalleryCardAnchor
          product={product}
          onClick={handleAnalyticsClickEvent}
        >
          <ProductGalleryCard
            product={product}
            eagerLoadImage={eagerLoadImage}
            isBusiness={isBusiness}
            dynamicTargetValue={product.offerId}
          />
        </ProductGalleryCardAnchor>
      </CardLinkRegion>
    </DeviceGalleryCardImpressionRegion>
  );
};

export default DeviceGalleryCard;
